import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  [types.GET_DEPARTMENTS_BEGIN](state) {
    state.departmentsGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_DEPARTMENTS_SUCCESS](state, departments) {
    state.departmentsGetError = null;
    state.departments = departments;
    state.departmentsGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_DEPARTMENTS_ERROR](state, err) {
    state.departmentsGetState = API_STATES.REQUEST_ERROR;
    state.departmentsGetError = err;
  },
  [types.DELETE_DEPARTMENT_BEGIN](state) {
    state.departmentDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_DEPARTMENT_SUCCESS](state) {
    state.departmentDeleteError = null;
    state.departmentDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_DEPARTMENT_ERROR](state, err) {
    state.departmentDeleteState = API_STATES.REQUEST_ERROR;
    state.departmentDeleteError = err;
  },
  [types.CREATE_DEPARTMENT_BEGIN](state) {
    state.departmentCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_DEPARTMENT_SUCCESS](state, data) {
    state.departmentCreateError = null
    state.departmentCreateState = API_STATES.REQUEST_SUCCESS
    state.department=data
  },
  [types.CREATE_DEPARTMENT_ERROR](state, err) {
    state.departmentCreateState = API_STATES.REQUEST_ERROR;
    state.departmentCreateError = err;
  },
  [types.UPDATE_DEPARTMENT_BEGIN](state) {
    state.departmentUpdateState =  API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_DEPARTMENT_SUCCESS](state, data) {
    state.departmentUpdateError = null
    state.department=data
    state.departmentUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_DEPARTMENT_ERROR](state, err) {
    state.departmentUpdateState = API_STATES.REQUEST_ERROR
    state.departmentUpdateError = err
  },

  [types.ADD_USER_DEPARTMENT_BEGIN](state,userId) {
    state.userDepartmentUpdating.push(userId)
  },
  [types.ADD_USER_DEPARTMENT_SUCCESS](state, { data, rootState }) {
    const index = findIndex(state.userDepartmentUpdating, data.userId);
    state.userDepartmentUpdating.splice(index, 1);
    rootState.app.formData.userDepartments.push(data)
    state.userDepartmentUpdateError = null
  },
  [types.ADD_USER_DEPARTMENT_ERROR](state, { err,userId }) {
    const index = findIndex(state.userDepartmentUpdating, userId);
    state.userDepartmentUpdating.splice(index, 1);
    state.userDepartmentUpdateError = err;
  },

  [types.DELETE_USER_DEPARTMENT_BEGIN](state, userId) {
    state.userDepartmentDeleting.push(userId);
  },
  [types.DELETE_USER_DEPARTMENT_SUCCESS](state, { userId, rootState }) {
    state.userDepartmentDeleteSuccessError = null;
    
    const index = findIndex(rootState.app.formData.userDepartments, { userId });
    rootState.app.formData.userDepartments.splice(index, 1)

    const index2 = findIndex(state.userDepartmentDeleting, userId);
    state.userDepartmentDeleting.splice(index2, 1);
  },
  [types.DELETE_USER_DEPARTMENT_ERROR](state, { err, userId }) {
    const index = findIndex(state.userDepartmentDeleting, userId);
    state.userDepartmentDeleting.splice(index, 1);
    state.userDepartmentDeleteSuccessError = err;
  }
};

export default mutations;
